import $ from 'jquery';


export default (selector) => {
    $(selector).css("width", $(selector).width() + "px !important")
};



// WEBPACK FOOTER //
// ./scripts/libs/block_width.js